export enum BOOLEAN_TO_ASYNCS {
  TRUE = 'true',
  FALSE = 'false',
}
